import { useMemo } from 'react'
import { IVerticalBlockItem } from '../../../types'
import { Container, Overlay, StyledVideo, TitleOverlay } from './Item.style'
import { usePlayer } from './PlayerContext'
import { DurationComp, TitleEpisodeComp } from './ItemComponents'
import { PlayWithCircle } from './icons'
import { usePreviewVideo } from './usePreviewVideo'

export const buildVideoSrc = (kid: string) =>
  `https://cdnapisec.kaltura.com/p/2748741/sp/274874100/playManifest/entryId/${kid}/seekFrom/0000/clipTo/3000/protocol/https/format/applehttp/a.m3u8`

export const Item = ({
  data,
  playing = false,
  showPoster = true,
}: {
  data: IVerticalBlockItem
  playing: boolean
  /** the feed holds the poster back until the section is near the screen */
  showPoster?: boolean
}) => {
  const { isMiniSeries } = usePlayer()
  const { title, poster, video, episode } = useMemo(() => {
    return {
      title: data.title,
      poster: data.poster,
      video: data.video,
      episode: data.episode,
    }
  }, [data.episode, data.poster, data.title, data.video])

  const { videoRef, isPlaying, play, pause } = usePreviewVideo(
    buildVideoSrc(video.kalturaId),
    playing
  )

  return (
    <Container
      onMouseEnter={play}
      onMouseLeave={pause}
      poster={showPoster ? poster : undefined}
      isMiniSeries={isMiniSeries}
    >
      {/* the source is set on play (usePreviewVideo) */}
      <StyledVideo
        ref={videoRef}
        width={isPlaying ? '100%' : '0px'}
        display={isPlaying ? 'block' : 'none'}
        muted
        playsInline
        preload='none'
        loop
      />
      <Overlay>
        {isMiniSeries && <PlayWithCircle />}
        {isMiniSeries && <TitleEpisodeComp ep={episode} />}
        <TitleOverlay isMiniSeries={isMiniSeries}>{title}</TitleOverlay>
        {!isMiniSeries && <DurationComp duration={video.duration} />}
      </Overlay>
    </Container>
  )
}
